module.exports = __webpack_public_path__ + "img/add-file.f041a5c4.svg";